/**
 * author: Soumya Shreyas
 */
import React, { useContext, useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import RegulationCreate from "../RegulationCreate/RegulationCreate";
import RiskConfigService from "../../../../core/service/RiskConfigService";
import NoRegulation from "../NoRegulation";
import RiskScoreMain from "../RiskScoreMain/RiskScoreMain";
import TabFilter from "../../../../components/TabFilter/TabFilter";
import { RegulationContext } from "../../../../App";
import RiskScoreAdminMain from "../RiskScoreAdminMain/RiskScoreAdminMain";

function RiskConfiguration({ t }) {
  const { glbRegulation, setGlbRegulation } = useContext(RegulationContext);
  const [list, setList] = useState([]);
  const [type, setType] = useState("REGULATION");
  const [regulationId, setRegulationId] = useState("");
  const [parent, setParent] = useState(0);
  const [addRiskParent, setAddRiskParent] = useState(0);
  const [defaultExpand, setDefaultExpand] = useState("");
  const [openRegulationSave, setOpenRegulationSave] = useState(false);
  const [configType, setConfigType] = useState("Supplier");
  var data = JSON.parse(localStorage.getItem("authority"));
  const filterData = [
    { name: t("Supplier.label"), value: t("Supplier.label") },
    { name: t("Company.label"), value: t("Company.label") },
  ];
  useEffect(() => {
    getRegulations();
  }, [glbRegulation]);
  const getRegulations = () => {
    RiskConfigService.getRegulations()
      .then((response) => {
        var filter = [];
        // console.log('glbRegulationglbRegulation',window.location.pathname)
        if(window.location.pathname=='/admin/configurations') {
          filter = response.data;
        } else {
          filter = response.data.filter(x=> x.id==glbRegulation.id); 
        }
        // filter = response.data;
        setList([...filter]);
        setType("REGULATION");
        setParent(0);
      })
      .catch((error) => { });
  };
  const handleCreate = (val) => {
    setOpenRegulationSave(val);
    getRegulations();
  };
  const handleShow = () => {
    setOpenRegulationSave(true);
  };
  const handleChildToggleContent = (data) => {
    setRegulationId(data.regulationId);
    if (data.childStatus === "Expand") {
      setType(data.type);
      getChildDetails(data.regulationId, data.paramId, data.configType);
    } else if (data.childStatus === "Close") {
      data.parent === 0 && setDefaultExpand(data.regulationId);
      data.parent === 0
        ? getRegulations()
        : getChildDetails(data.regulationId, data.parent, data.configType);
    }
  };
  const getChildDetails = (regulationId, paramId, type = configType) => {
    RiskConfigService.getRiskDetails(regulationId, paramId, type)
      .then((response) => {
        var data = response.data;

        if (data) {
          setList(data);
          if (data.parent) {
            setParent(data.parent.id);
          } else {
            setParent(0);
          }
          setAddRiskParent(data.id);
        }
      })
      .catch((error) => {
        //ErrorHandlingService.handleError(error.response.status);
      });
  };
  const callbackTab = (val) => {
    setConfigType(val);
    let data = {
      type: type,
      childStatus: "Close",
      parent: parent,
      regulationId: "",
      configType: val,
    };
    handleChildToggleContent(data);
  };
  return (
    <>
      <div className="RiskScoreMain">
        <div className="List_header pb-2">
          <h5 className="MH m-0">{t("Configurations.label")}</h5>
          <div className="d-flex align-items-center">
            <div className="choose_comapny_supplier_box me-2">
              <TabFilter data={filterData} callbackValue={callbackTab} />
            </div>
            {data.roles.includes("SUPER_ADMIN") && (
              <div className=" text-end">
                <button className="btn btn-primary" onClick={handleShow}>
                  {t("AddNewRegulation.label")}
                </button>
              </div>
            )}
          </div>
        </div>

        {openRegulationSave && (
          <RegulationCreate
            handleCreateReg={handleCreate}
            configType={configType}
          />
        )}
        {window.location.pathname == '/admin/configurations' && (() => {
          switch (type) {
            case "REGULATION":
              return list.length > 0 ? (
                list?.map((item) => (
                  <RiskScoreAdminMain
                    key={item.id}
                    list={item}
                    listType={type}
                    handleChildToggle={handleChildToggleContent}
                    selectedRegulation={regulationId}
                    parent={parent}
                    addRiskParent={addRiskParent}
                    configType={configType}
                  />
                ))
              ) : (
                <NoRegulation />
              );
            case "RISK":
              return (
                <RiskScoreAdminMain
                  key={list.id}
                  list={list}
                  listType={type}
                  handleChildToggle={handleChildToggleContent}
                  selectedRegulation={regulationId}
                  parent={parent}
                  addRiskParent={addRiskParent}
                  configType={configType}
                />
              );
            default:
              return null;
          }
        })()}
        {window.location.pathname == '/company_admin/configurations' && (() => {
          switch (type) {
            case "REGULATION":
              return list.length > 0 ? (
                list?.map((item) => (
                  <RiskScoreMain
                    key={item.id}
                    list={item}
                    listType={type}
                    handleChildToggle={handleChildToggleContent}
                    selectedRegulation={regulationId}
                    parent={parent}
                    addRiskParent={addRiskParent}
                    configType={configType}
                  />
                ))
              ) : (
                <NoRegulation />
              );
            case "RISK":
              return (
                <RiskScoreMain
                  key={list.id}
                  list={list}
                  listType={type}
                  handleChildToggle={handleChildToggleContent}
                  selectedRegulation={regulationId}
                  parent={parent}
                  addRiskParent={addRiskParent}
                  configType={configType}
                />
              );
            default:
              return null;
          }
        })()}
      </div>
    </>
  );
}

export default withTranslation()(RiskConfiguration);
